import React from 'react'
import logo from '../assets/images/logo.png'
import Button from '../components/Button'
import {Link} from 'react-router-dom'


const Login = () => {
  return (
    <>
      <div className='login-background'>
        <div>
          <div className='form-container mt-24'>
            <form action="" className='form-background'>
              <img src={logo} alt="laundry basket logo" className='logo'/>
              <h1 className='login-title'>Login</h1>
              <p className='login-subtitle'>Enter your credentials to access your account</p>
              <div className='flex flex-col w-96 gap-10 input-container'>
                <label htmlFor="">
                <p className='input-label'>Email Address</p> 
                  <input type='text' placeholder='Enter your email' className='input-style'/>
                </label>
                
                <label htmlFor="">
                <p className='input-label'>Enter your password</p> 
                  
                  <input type='password' placeholder='Password' className='input-style'/>
                </label>
                
              </div>
              <Link to='/' style={{width: '100%'}}>
                <Button style={{width: '100%'}}> Log into account</Button>
              </Link>
              <Link to='/forget-password' style={{width: '100%'}}>
                <Button style={{background: 'none', width: '100%', color: '#434C5A' }}>Forget Password?</Button>
              </Link>
              
            </form>
          </div>
        </div>
      </div>
    </>
  )
}

export default Login